// PushPermissionPrompt — pre-prompt dialog/sheet до native запроса разрешения.
// Spec: docs/ui-spec/system.push-permission.{desktop,mobile}.md

import {
	BottomSheet,
	BottomSheetContent,
	BottomSheetDescription,
	BottomSheetTitle,
} from "@studyhub/ui/components/bottom-sheet";
import { Button } from "@studyhub/ui/components/button";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@studyhub/ui/components/dialog";
import { IconBell } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { useIsLgUp } from "@/lib/platform-detect";

interface PushPermissionPromptProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	onAllow: () => void;
	onLater: () => void;
}

export function PushPermissionPrompt({
	open,
	onOpenChange,
	onAllow,
	onLater,
}: PushPermissionPromptProps) {
	const { t } = useTranslation("notifications");
	const isDesktop = useIsLgUp();

	if (isDesktop) {
		return (
			<Dialog open={open} onOpenChange={onOpenChange}>
				<DialogContent className="sm:max-w-md">
					<DialogHeader className="items-center text-center">
						<div className="flex h-12 w-12 items-center justify-center rounded-full bg-primary/15 text-primary">
							<IconBell size={22} />
						</div>
						<DialogTitle className="mt-2">{t("pushPermission.title")}</DialogTitle>
						<DialogDescription>{t("pushPermission.subtitle")}</DialogDescription>
					</DialogHeader>
					<DialogFooter className="sm:justify-center">
						<Button variant="ghost" className="cursor-pointer" onClick={onLater}>
							{t("pushPermission.later")}
						</Button>
						<Button className="cursor-pointer" onClick={onAllow}>
							{t("pushPermission.allow")}
						</Button>
					</DialogFooter>
				</DialogContent>
			</Dialog>
		);
	}

	return (
		<BottomSheet open={open} onOpenChange={onOpenChange}>
			<BottomSheetContent className="px-6 pb-[max(1.5rem,env(safe-area-inset-bottom))]">
				<div className="grid items-center gap-1.5 pt-2 text-center">
					<div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-primary/15 text-primary">
						<IconBell size={22} />
					</div>
					<BottomSheetTitle className="mt-2">{t("pushPermission.title")}</BottomSheetTitle>
					<BottomSheetDescription>{t("pushPermission.subtitle")}</BottomSheetDescription>
				</div>
				<div className="mt-4 flex flex-col gap-2">
					<Button size="lg" className="cursor-pointer min-h-[44px]" onClick={onAllow}>
						{t("pushPermission.allow")}
					</Button>
					<Button
						size="lg"
						variant="ghost"
						className="cursor-pointer min-h-[44px]"
						onClick={onLater}
					>
						{t("pushPermission.later")}
					</Button>
				</div>
			</BottomSheetContent>
		</BottomSheet>
	);
}
